<div class="borderColor relative mb-2 rounded-xl border px-5 pt-4 pb-6 shadow-xl">
  <div class="flex w-full items-start justify-between gap-6 border-b border-gray-300 pb-4">
    <div class="relative w-[10.5rem] overflow-hidden bg-gray-300 shadow-lg">
      @if (isLoadingFile()) {
        <app-loading />
      } @else {
        <div
          [class.right-0]="isArabic()"
          [class.left-0]="!isArabic()"
          class="absolute top-[-38px] right-[1rem] flex h-full w-[1rem] rotate-[314deg] items-center justify-center bg-green-700 text-sm text-white">
          <span class="absolute top-[50px] left-[-2px] rotate-[92deg] text-center text-[10px]">
            {{ isArabic() ? "عرض" : "offer" }}
          </span>
        </div>
        <img [src]="previewImageUrl()" class="rounded-lg object-contain shadow-2xl" alt="File Preview" />
      }
    </div>
    <div class="w-full">
      <h3 class="my-2 mb-6 text-xl font-bold">
        {{ productTitle() }}

        <span class="text-md font-medium text-gray-500">
          ({{
            isArabic()
              ? "اشتر" + " " + buyQuantity() + "واحصل على" + " " + getQuantity() + "مجانا"
              : "B" + buyQuantity() + "G" + getQuantity()
          }})
        </span>
      </h3>
      <div class="flex w-full flex-col gap-6">
        @for (product of products(); track product.id) {
          <div class="flex w-full items-start justify-between border-b border-gray-300 pb-2">
            <div class="flex flex-col" [class.gap-0.5]="isReadOnly()">
              <p [class.text-sm]="isReadOnly()" [class.font-semibold]="isReadOnly()">
                {{ isArabic() ? product.product.titleAr : product.product.titleEn }}
              </p>

              @if (isReadOnly()) {
                <div class="flex items-center gap-5 text-[13px] text-gray-600">
                  <div class="flex items-center gap-2">
                    <app-customer-price-icon />
                    <span>
                      {{ product.product.peoplePrice }}
                      <span i18n="@@EGP">EGP</span>
                    </span>
                  </div>
                  <div class="flex items-center gap-2">
                    <app-business-price-icon />
                    {{ product.product.storePrice }}
                    <span i18n="@@EGP">EGP</span>
                  </div>
                </div>
                <div class="flex items-center gap-5 text-[13px] text-gray-600">
                  <div class="flex items-center gap-2">
                    <app-mfg-exp-dates-icon />
                    <span>{{ concatenationDate(product.product.mfgDate, product.product.expDate) }}</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <app-batch-number-icon />
                    <span>{{ product.product.batchNumber }}</span>
                  </div>
                </div>
              } @else {
                <div class="grid grid-cols-2 gap-x-6 gap-y-2">
                  <div class="flex items-center gap-2">
                    <app-customer-price-icon />
                    <span>
                      {{ product.product.peoplePrice }}
                      <span i18n="@@EGP">EGP</span>
                    </span>
                  </div>
                  <div class="flex items-center gap-2">
                    <app-business-price-icon />
                    <span>
                      {{ product.product.storePrice }}
                      <span i18n="@@EGP">EGP</span>
                    </span>
                  </div>

                  <div class="flex items-center gap-2">
                    <app-mfg-exp-dates-icon />
                    <span>{{ concatenationDate(product.product.mfgDate, product.product.expDate) }}</span>
                  </div>
                  <div class="flex items-center gap-2">
                    <app-batch-number-icon />
                    <span>{{ product.product.batchNumber }}</span>
                  </div>
                </div>
              }

              <div class="mt-2">
                <app-item-quantity-status
                  [quantity]="product.quantity.toString()"
                  [packageQuantity]="getPackageDataFor(product).packageQuantity"
                  [notPackageRows]="getPackageDataFor(product).notPackageRows"
                  [editable]="isPrinted() && !isReadOnly()"
                  [isPrinted]="isPrinted() && !isReadOnly()"
                  [isPartiallyPackaged]="isPartiallyPackaged()"
                  (open)="onOpenPackageModal(product)"
                  [receiveReturnedProductsView]="receiveReturnedProductsView()" />
              </div>
            </div>

            <div>
              <div
                [class.border-green-500]="product.quantity - product.freeQuantity === 0"
                [class.borderColor]="product.quantity - product.freeQuantity > 0"
                class="flex gap-2 rounded-lg border px-2 py-1">
                @if (product.quantity - product.freeQuantity === 0) {
                  <span class="text-green-500">+{{ product.freeQuantity + " " + "مجانا" }}</span>
                } @else {
                  <span i18n="@@quantity">Quantity</span>
                  <span>:</span>

                  <span>{{ product.quantity - product.freeQuantity }}</span>
                }
              </div>
              @if (product.quantity - product.freeQuantity > 0) {
                <div class="my-2 flex gap-2 rounded-lg border border-green-500 px-2 py-1 text-center text-green-500">
                  <span>
                    {{ "+" + " " + product.freeQuantity + " " + "مجانا" }}
                  </span>
                </div>
              }
            </div>
          </div>
        }
        @if (showOfferShortageActions()) {
          <div class="mt-2 flex items-center justify-end gap-3">
            <button
              type="button"
              (click)="onDropAllClick()"
              class="borderTabsColor textTabsColor hover-bg-primary-10 flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl border bg-white px-4 py-2.5 text-sm font-semibold transition-colors">
              <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              {{ isArabic() ? "إزالة الكل" : "Drop All" }}
            </button>

            <button
              type="button"
              (click)="onConvertClick()"
              class="bgTabsColor hover-bg-primary-hover flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white transition-colors">
              <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              {{ isArabic() ? "تحويل إلى منتجات" : "Convert to Products" }}
            </button>
          </div>
        } @else if (confirmAction()) {
          <span class="mt-4 inline-block rounded-lg bg-gray-100 px-4 py-2 text-[13px] font-bold text-gray-600">
            {{
              confirmAction() === "CONVERT"
                ? isArabic()
                  ? "تم التحويل"
                  : "Converted"
                : isArabic()
                  ? "تم الإسقاط"
                  : "Dropped All"
            }}
          </span>
        }
      </div>
    </div>
  </div>
  <div class="flex flex-col gap-1.5 border-t border-gray-100 pt-3 text-sm">
    <div class="flex items-center justify-end gap-2">
      <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPeoplePrice">Total People Price:</span>
      <p class="w-24 text-left">
        {{ (totalCustomerPrice() || 0).toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
    <div class="flex items-center justify-end gap-2">
      <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPharmacyPrice">Total Pharmacy Price:</span>
      <p class="w-24 text-left">
        {{ (totalPharmacyPrice() || 0).toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
    <div class="flex items-center justify-end gap-2 text-green-500">
      <span class="w-36 text-right font-bold">{{ (isArabic() ? "خصومات العرض" : "Offer Discounts") + ":" }}</span>
      <p class="w-24 text-left">
        {{ ((totalPharmacyPrice() || 0) - +(totalBusinessPrice() || 0)).toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
    <div class="flex items-center justify-end gap-2">
      <span class="w-36 text-right font-bold text-gray-800" i18n="@@total">Total:</span>
      <p class="w-24 text-left">
        {{ (+(totalBusinessPrice() || 0)).toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
  </div>
</div>
